import { Component, Input } from '@angular/core';
import { fileSizeCalculator } from 'src/app/utils/fileSizeCalculator';

@Component({
  selector: 'apc-extra-fields-file-form',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss']
})
export class FileComponent {
  @Input() public form: any;
  @Input() public typesDropdown: any;
  @Input() public fileFormData: FormData;
  @Input() public fileRequired: boolean;
  public initialNotifyWhenExpired: boolean;

  async ngOnInit() {
    this.initialNotifyWhenExpired = this.form.value.notifyWhenExpired;
    this.fileFormData.delete('file');
  }

  toggleAlert() {
    this.form.controls['dateEnd'].setErrors(null);
  }

  handleFileInput(files: FileList) {
    this.form.markAsDirty();
    if (files.item(0)) {
      this.fileRequired = false;
      this.fileFormData.delete('file');
      this.fileFormData.append('file', files.item(0));
      this.form.controls.fileName.setValue(files.item(0).name);
      this.form.controls.fileSize.setValue(fileSizeCalculator(files.item(0).size));
    }
  }

  findDropdownRenderValue() {
    let findObject = this.typesDropdown.find((el) => el.identifier == this.form.value.extraTypeIdentifier);
    return findObject ? findObject.name : '';
  }
}
